import Option, {OptionData} from "@/types/clients/esquire/data/general/option";

export interface IPendingPayment {
    guid: string;
    option: OptionData | null;
}

export default class PendingPayment {
    public guid: string;
    public option: null|Option;

    constructor(data: IPendingPayment) {
        this.guid = data.guid as string;
        this.option = data.option ? new Option(data.option as OptionData) : null;
    }

  toDTO(): IPendingPayment {
    return {
      guid: this.guid,
      option: this.option ? this.option.toDTO() : null
    };
  }
}
